import * as React from "react"
import { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';

// COMPONENTS
import Layout from "../components/layout";
import { StaticImage } from "gatsby-plugin-image";
import Seo from "../components/Seo";
import { Text, Flex, Box, Heading } from "rebass";
import Loader from "../components/Loader";


const schema = yup.object({
  email: yup.string().email().required(),
  subject: yup.string().min(1).max(40).required(),
  message: yup.string().min(1).max(5000).required()
}).required();

// markup
const AboutPage = () => {
  const [isPostSuccessful, setIsPostSuccessful] = useState(false);
  const { register, handleSubmit, watch, reset, formState, formState: { errors, isSubmitting, isSubmitted, isSubmitSuccessful, isValid, isDirty } } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur"

  });

  function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  const onSubmit = async (data) => {
    const response = await fetch('/contact', {
      method: 'POST',
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "Contact Form",
        ...data
      }),
    })

    if (response.ok) {
      console.log("good response")
      setIsPostSuccessful(true)
    }
  }

  return (
    <Layout>
      <Seo title="Contact - N.Johnstone&Co" />
      <Box height="900px">
        {(!isSubmitted || !isValid) &&
          < div className="contact-page page-wrapper">
            <div>
              <div>
                <StaticImage placeholder="blurred" src="../images/nova_portrait.jpg" alt="nova" />
                <form className="form-basic" action="/contact" onSubmit={handleSubmit(onSubmit)} name="Contact Form" method="POST" data-netlify="true">
                  <h1>Let's Talk About You</h1>
                  <input type="hidden" name="form-name" value="Contact Form" />
                  <input name="email" {...register("email")} type="text" placeholder="Email Address..."></input>
                  {errors.email && <Text mb={3}>{errors.email?.message}</Text>}
                  <input name="subject" {...register("subject")} type="text" placeholder="Subject..."></input>
                  {errors.subject && <Text mb={3}>{errors.subject?.message}</Text>}
                  <textarea name="message" {...register("message")} type="text" placeholder="Message..."></textarea>
                  {errors.message && <Text sx={{ mb: 3, textIndent: 3 }} >{errors.message?.message}</Text>}
                  <button className="primary-btn" type="submit">send</button>
                </form>
              </div>
            </div>
          </div>}

        {isSubmitting && !isPostSuccessful &&
          <Flex height="100%" justifyContent="center" alignItems="center">
            <Loader />
          </Flex>}

        {isPostSuccessful &&
          <Flex height="100%" justifyContent="center" alignItems="center">
            <Box textAlign="center">
              <Heading mb={3}>Thank you for the email!</Heading>
              <Text mb={4}> I'll be in touch with you shortly.</Text>
              <a className="primary-btn" href="/">Back Home</a>
            </Box>
          </Flex>}

        {(!isPostSuccessful && isSubmitted) &&
          < Flex height="100%" justifyContent="center" alignItems="center">
            <Box textAlign="center">
              <Heading mb={3}>Oups!</Heading>
              <Text mb={4}>We couldn't send your email.</Text>
              <a className="primary-btn" href="/contact">Try Again</a>
            </Box>
          </Flex>}
      </Box>
    </Layout >
  )
}

export default AboutPage;